/**
 * Phase 25 — above a live result: the tags could not be read, or a rule
 * tests a tag no enabled tag of that kind has — either way those conditions
 * do nothing, and the operator is told which (hours: `HourTagNotes`).
 * For Media Devoted | Created By Ciro Autiero
 */
import type { FC } from 'react';
import { AlertTriangle } from 'lucide-react';
import type { DropGenTagsRead } from '@trafficpulse/shared';

import { cn } from '@/lib/utils';

import { RULE_SURFACES, type RuleSurface } from './rule-surfaces';

const Note: FC<{ text: string }> = ({ text }) => (
  <p className="flex items-start gap-1.5 rounded-lg border border-warning/40 bg-warning/5 px-3 py-2 text-xs text-foreground">
    <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-warning" aria-hidden />
    {text}
  </p>
);

export const TagReadNotes: FC<{ read: DropGenTagsRead | undefined; surface: RuleSurface; className?: string }> = ({ read, surface, className }) => {
  const missing = read?.missingTags ?? [];
  if (!read?.tagsUnavailable && missing.length === 0) return null;
  const { item, tags } = RULE_SURFACES[surface];
  return (
    <div className={cn('flex flex-col gap-1.5', className)} data-testid="tag-read-notes">
      {read?.tagsUnavailable ? <Note text={`The ${item} tags could not be read — rules that test a tag do nothing until they load.`} /> : null}
      {missing.length > 0 ? (
        <Note text={`No enabled ${item} tag is named ${missing.map((n) => `"${n}"`).join(', ')} — those conditions do nothing. Pick another tag or re-create it on ${tags.page}.`} />
      ) : null}
    </div>
  );
};
